import React , { useEffect , useState, lazy }   from "react";
import { PostDataPromise } from "../Functions/SendingData";
import { LoadingWLogo } from "../LoadingWLogo";
import NoMatch from "../../pages/NoMatch";
import { baseText } from "../../Lang/fa/BaseText";

// import MainSlider1 from "../HomeComp/MainView/MainSlider1";
// import SingelSlider from "../HomeComp/Home2Web/SingelBannerV2";
// import NavPadding from "../HomeComp/Home2Web/NavPadding";
// import ShopViewMainInfo2 from "../HomeComp/ShopView/ShopViewV2Main/ShopViewMainInfoV2";
// import SubCategorySlider from "../HomeComp/Sliders/SubCategorySlider";
// import CategorySlider from "../HomeComp/Sliders/CategorySlider";
// import GoodsListV2 from "../HomeComp/MainView/GoodsListV2";
// import BreadcrombPageBuilder from "../HomeComp/MainView/BreadcrombPageBuilder";
// import SubGroupSliderV2 from "../HomeComp/MainView/SubGroupSliderV2";
// import MainSliderHome2 from "../HomeComp/Home2Web/MainsliderHomeV2";

// import TagGroupSlider from "../HomeComp/MainView/TagGroupSlider";
// import HomeWebView from "../HomeComp/HomeWeb/HomeWebView";
// import BrandsApp from "../HomeComp/MainView/BrandsApp";
// import BannerDouble from "../HomeComp/MainView/BannerDouble";
// import GoodsApp from "../HomeComp/MainView/GoodsApp";
// import Shops2 from "../HomeComp/Home2Web/ShopsV2";
// import Brands2 from "../HomeComp/Home2Web/BrandsV2";
// import GoodList2 from "../HomeComp/Home2Web/GoodSliderV2";
// import ViewFullSlider from "../HomeComp/MainView/ViewFullSlider";
// import RibobonAutoBlogPost from "./RibobonAutoBlogPost";
// import RibbonSuggetGood from "./RibbonSuggetGood";
// import Intro1 from './Intro1';
// import SurveyComp from './SurveyComp';


const MainSliderHome2 = lazy(()=> import("../HomeComp/Home2Web/MainsliderHomeV2"));
const SubGroupSliderV2 = lazy(()=> import("../HomeComp/MainView/SubGroupSliderV2"));
const BreadcrombPageBuilder = lazy(()=> import("../HomeComp/MainView/BreadcrombPageBuilder"));
const GoodsListV2 = lazy(()=> import("../HomeComp/MainView/GoodsListV2"));
const CategorySlider = lazy(()=> import("../HomeComp/Sliders/CategorySlider"));
const SubCategorySlider = lazy(()=> import("../HomeComp/Sliders/SubCategorySlider"));
const ShopViewMainInfo2 = lazy(()=> import("../HomeComp/ShopView/ShopViewV2Main/ShopViewMainInfoV2"));
const NavPadding = lazy(()=> import("../HomeComp/Home2Web/NavPadding"));
const SingelSlider = lazy(()=> import("../HomeComp/Home2Web/SingelBannerV2"));
const MainSlider1 = lazy(()=> import("../HomeComp/MainView/MainSlider1"));

const TagGroupSlider = lazy(()=> import("../HomeComp/MainView/TagGroupSlider"));
const HomeWebView = lazy(()=> import("../HomeComp/HomeWeb/HomeWebView"));
const BrandsApp = lazy(()=> import("../HomeComp/MainView/BrandsApp"));
const BannerDouble = lazy(()=> import("../HomeComp/MainView/BannerDouble"));
const GoodsApp = lazy(()=> import("../HomeComp/MainView/GoodsApp"));
const Shops2 = lazy(()=> import("../HomeComp/Home2Web/ShopsV2"));
const Brands2 = lazy(()=> import("../HomeComp/Home2Web/BrandsV2"));
const GoodList2 = lazy(()=> import("../HomeComp/Home2Web/GoodSliderV2"));
const ViewFullSlider = lazy(()=> import("../HomeComp/MainView/ViewFullSlider"));
const RibobonAutoBlogPost = lazy(()=> import("./RibobonAutoBlogPost"));
const RibbonSuggetGood = lazy(()=> import("./RibbonSuggetGood"));
const Intro1 = lazy(()=> import('./Intro1'));
const IntroPerfume = lazy(()=> import('./IntroPerfume'));
const SurveyComp = lazy(()=> import('./SurveyComp'));
const IntroLuxGardi = lazy(() => import("./IntroLuxGardi"));


const PageBuilder = (props)=>{
    const {name={} ,params={}  , filters={}} = props
    const [loading, setLoading] = useState(true);
    const [pageData, setPageData] = useState([])
    const [pagename, setPagename] = useState([])
    const [pageparams, setPageparams] = useState([])
    
    useEffect(()=>{
        if(props.name) {
            let paramsCheck = checkObj(params , pageparams)
            if(props.name !== pagename || paramsCheck){
                setPagename(props.name)  
                setPageparams(params)  
                if(props.ribbons){
                    setPageData(props.ribbons)
                    setLoading(false)
                }else{
                    getData()  
                }
            }
        }        
    },[ params , name])
    const checkObj =(obj1, obj2)=>{
        let key1 = Object.keys(obj1)
        let key2 = Object.keys(obj2)
        key1.sort((a , b)=> a-b )
        key2.sort((a , b)=> a-b )
        if(key1.length !== key2.length){
            return true
        }
        for (let i = 0; i < key1.length; i++) {
            const element = key1[i];
            if(!obj2[element]){
                return true
            }
            if(obj1[element] !== obj2[element]){
                return true
            }
        }
        return false
    }

    const getData = async (name = props.name ,paramsv= params) => {
        let formData = new FormData();
        formData.append('VI_NAME', name);

        let keys = Object.keys(paramsv)
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            formData.append(key,paramsv[key]);
        }
        if(localStorage.getItem("token")){
            formData.append("api_token", localStorage.getItem("token"));
            formData.append("U_CODE", JSON.parse(localStorage.getItem("userdata")).usercode);
        }
        let data = await PostDataPromise(process.env.REACT_APP_API + '/api/v1/exb/view_ribbon/select_by_vi_name',formData);
        let response = JSON.parse(data)
        if (response.status === 'success') {
            setLoading(false)
            if(response.data[0]){
                setPageData(response.data[0].VIEW_RIBBON)
            }
        } 
        else if (response.status === 'error') {
            setPageData([{
                RIBB_CODE: 9999,
                VI_RIBB_DATA: response.data.message
            }])
            setLoading(false)
        } else if (response.status === 'error-no-internet') {
            setPageData([{
                RIBB_CODE: 9999,
                VI_RIBB_DATA: "no-internet"
            }])
            setLoading(false)
        } else {
            setPageData([{
                RIBB_CODE: 9999,
                VI_RIBB_DATA: "server error"
            }])
            setLoading(false)
        }
    }
    
   
    const makeItems = () => {
        let items = [];
        pageData.forEach((v,i) => {
            switch (v.RIBB_CODE) {
                case 9999:
                    //یه جای کار میلنگه 404
                    items.push(
                        <NoMatch mgs={v.VI_RIBB_DATA}/>
                    )
                    break;
                case 1200:
                items.push(
                    <div className="padding" key={i}>
                    </div>
                )
                    break;
                case 4:
                    items.push(
                        <div className="text" key={i}>
                            {v.VI_RIBB_DATA}
                        </div>
                    )
                    break;
                case 5:
                    items.push(
                        <div className="text"key={i}>
                            {v.VI_RIBB_DATA}
                        </div>
                    )
                    break;
                case 11:
                // لیست محصولات
                items.push(
                    <GoodsListV2 {...props} groupData={{EN_NAME:filters.EN_NAME}} key={i}/> 
                )
                break;
                case 18:
                    //بنر فروشگاه
                    items.push(
                        <ShopViewMainInfo2 info={props.info} data={v.VI_RIBB_DATA} productList={v.EXB_SLIDER} number={i} code={v.RIBB_CODE} key={i}/> 
                    )
                break;
                case 141:
                    //اینترو کمپین 1
                    items.push(
                        <Intro1 {...props} data={v.VI_RIBB_DATA} key={i}/> 
                    )
                    break;
                case 142:
                    // پرسشنامه رنگ مو
                    items.push(
                        <SurveyComp {...props} key={i}/>
                    )
                    break;
                case 143:
                    //محصولات پیشنهادی1
                    items.push(
                        <RibbonSuggetGood {...props} data={v.this.props.data} key={i}/> 
                    )
                    break;
                // case 145: 
                //     //بلاگ
                //     items.push(
                //         <RibbonBlogPostGood {...props} data={v.VI_RIBB_DATA} key={i}/>  
                //     )
                //     break;               
                case 147:
                    //بلاگ تگ
                    items.push(
                        <RibobonAutoBlogPost {...props} data={v.BLOG_POSTS}  key={i}/>
                    )
                    break;
                case 148:
                    items.push(
                        <MainSlider1 data={v.VI_RIBB_DATA} productList={v.EXB_SLIDER} number={i} code={v.RIBB_CODE} key={i}/>
                    )
                    break;
                case 150:
                case 172:
                    // بنر دوتایی app
                    items.push(
                        <BannerDouble data={v.VI_RIBB_DATA}  productList={v.EXB_SLIDER} number={i} code={v.RIBB_CODE} {...props} key={i}/>
                    )
                    break;
                case 152:
                    // محصولات برتر app
                    items.push(
                        <GoodsApp data={v.VI_RIBB_DATA} goods={v.BEST_PRODUCT} number={i} key={i}/>
                    )
                    break;          
                case 154:
                    // برندها app
                    items.push(
                        <BrandsApp data={v.VI_RIBB_DATA} brands={v.BRANDS} number={i} key={i}/>
                    )
                    break;
                case 155:
                    // محصولات جدید app
                    items.push(
                        // <GoodsApp data={v.VI_RIBB_DATA} goods={v.NEW_PRODUCT} number={i}/>
                        <GoodList2 data={v.VI_RIBB_DATA} goods={v.NEW_PRODUCT} number={i} key={i}/>
                    )
                    break; 
                case 157:
                    //تگ ها مدل 1
                    if(v.SUB_GROUPS){
                        items.push(
                            <TagGroupSlider {...props} groupData={{sub_groups:v.SUB_GROUPS}}  key={i}/> 
                        )
                    }
                    break;
                case 158: 
                    //هدر صفحه گروه
                    items.push(
                        <ViewFullSlider {...props} groupData={{group_img:v.GROUPS_IMG, IMG: filters.IMG , NAME: filters.NAME , breadData: filters.breadData}} key={i} />
                    )
                    break;
                case 159:
                    // زیرگروه ها مدل 1
                    if(v.SUB_GROUPS){
                        items.push(
                            <SubGroupSliderV2 {...props} groupData={{sub_groups:v.SUB_GROUPS}}  key={i}/> 
                        )
                    }
                    break;
                case 160:
                    // اسلایدار مدل 1
                    items.push(
                        <ViewFullSlider {...props} groupData={{ IMG: filters.IMG , NAME: filters.NAME , breadData: filters.breadData}} key={i} />  
                    )
                    break;
                case 161:
                    // بلاگ کتگوری
                    items.push(
                        <RibobonAutoBlogPost {...props} data={v.VI_RIBB_DATA} key={i}/> 
                    )
                    break;
                case 163:
                    //هدر صفحه زیرگروه
                    items.push(
                        <ViewFullSlider {...props} groupData={{group_img:v.GROUPS_IMG, IMG: filters.IMG , NAME: filters.NAME , breadData: filters.breadData}} key={i} />
                    )
                    break;
                case 164:
                    //پرفروشترین هوم
                    items.push(
                        <HomeWebView {...props} groupData={v.BEST_SALE_PRODUCT_HOME} data={v.VI_RIBB_DATA} key={i} number={i}/>
                    )
                    break;                    
                    //پربازدیدترین هوم
                case 165:
                    items.push(
                        <HomeWebView {...props} groupData={v.BEST_VIEW_PRODUCT_HOME} data={v.VI_RIBB_DATA} key={i} number={i}/>
                    )
                    break;
                case 166:
                    //هدر صفحه تگ
                    items.push(
                        <ViewFullSlider {...props} groupData={{group_img:v.GROUPS_IMG, IMG: filters.IMG , NAME: filters.NAME , breadData: filters.breadData}} key={i} />
                    )
                    break;
                case 167:
                    //   جذاب ترین محصولات app
                    items.push(
                        <GoodsApp data={v.VI_RIBB_DATA} goods={v.BEST_VIEW_PRODUCT_APP} number={i} key={i}/>
                    )
                    break;  
                case 168:
                    //اسلایدر home2
                    items.push(
                        <MainSliderHome2 {...props} data={v.VI_RIBB_DATA} productList={v.EXB_SLIDER} number={i} code={v.RIBB_CODE} key={i}/>
                    )
                    break;
                case 169 :
                    //فروشگاه ها home2
                    items.push(
                        <Shops2 data={v.VI_RIBB_DATA} shops={v.SHOPS} number={i} key={i}/>
                    )
                    break;
                case 170:
                    //full banner
                    items.push(
                        <SingelSlider data={v.VI_RIBB_DATA} productList={v.EXB_SLIDER} number={i} code={v.RIBB_CODE} key={i}/>
                    )
                    break; 
                case 171:
                // نوار محصولات home2
                    items.push(
                        <GoodList2 {...props} data={v.VI_RIBB_DATA} productList={v.EXB_SLIDER} code={v.RIBB_CODE} number={i} classname='home2' search={props.search} key={i}/>
                    )
                    break; 
                case 173:
                // برندها home2
                    items.push(
                        <Brands2 data={v.VI_RIBB_DATA} brands={v.BRANDS} number={i} key={i}/>
                    )
                    break; 
                case 174:
                // فاصله منو نوبار
                    items.push(
                        <NavPadding data={v.VI_RIBB_DATA} number={i} key={i}/>
                    )
                    break; 
                case 175:
                // نوار دسته بندی ها
                    items.push(
                        <SubCategorySlider subgroup={v.SUB_GROUPS} number={i} key={i}/>
                    )
                    break;  
                case 176:
                // اسلایدر استاتیک دسته بندی
                    items.push(
                        <CategorySlider {...props} data={v.VI_RIBB_DATA} key={i}/>
                    )
                    break;
                case 177:
                // بردکرامب
                    items.push(
                        <BreadcrombPageBuilder {...props} groupData={{group_img:v.GROUPS_IMG, IMG: filters.IMG , NAME: filters.NAME , breadData: filters.breadData}} key={i} />
                    )
                    break;
                case 178:
                    //اینترو کمپین عطر 
                    items.push(
                        <IntroPerfume {...props} data={v.VI_RIBB_DATA} key={i}/> 
                    );
                    break;
                case 179:
                    //اینترو کمپین لوکس گردی 
                    items.push(
                        <IntroLuxGardi {...props} data={v.VI_RIBB_DATA} key={i}/> 
                    );
                    break;
                default:
                    break;
            }
        });
        return items
    }
    if(!loading){
        if(pageData.length > 0){
            return makeItems()
        }else{
            return <div className="empty">{baseText.notmatch}</div>
        }
    }else{
        return <LoadingWLogo/>
    }
}
export default PageBuilder